import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import Cookies from 'js-cookie'
import i18n from '@/plugins/vuei18n'

/* global localStorage */

Vue.use(Vuex)

function defaultPagination() {
  return {
    page: 1,
    totalItems: 0,
    rowsPerPage: parseInt(Cookies.get('defaultRowsPerPage')) || 10,
    rowsPerPageItems: [ 5, 10, 20, 50, { text: i18n.t('data-table.all'), value: -1 }]
  }
}

export default new Vuex.Store({
  state: {
    storageTypes: null,
    agencies :[],
    archiveFilters:[],
    schemaBuilder: {
      name: '',
      document_type_id: null,
      type: 1,
      status: 1,
      teams: [],
      fields: [],
      confirmation: 0
    },
    formPayload:{},
    relatedSchemas: [],
    relatedGroupTypes : [],
    relatedGroup : [],
    relatedValuesType : [],
    relatedValues : [],
    lang : Cookies.get('lang') || process.env.VUE_APP_LOCALE || navigator.language.substr(0, 2),
    teams: [],
    users: [],
    fieldTypes: [],
    token: localStorage.getItem('access_token') || '',
    tokenExpiration: localStorage.getItem('token_expiration') || null,
    refreshToken: localStorage.getItem('refresh_token') || '',
    authStatus: '',
    snack: {},
    darkTheme: Cookies.get('darkTheme') || false,
    formPagination: defaultPagination(),
    pagination: defaultPagination(),
    formViewOptions: {
      columnWidth: 150,
      hiddenFields: [],
    },
    forms: {
      amount: 0,
      headers: [],
      records: [],
      schema: null
    },
    isMobileAppWebView: false,
  },
  getters,
  mutations,
  actions
})
